const DisplayIconSecondary = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100"
    height="100"
    fill="none"
    viewBox="0 0 100 100"
  >
    <path
      fill="#CFCFCF"
      d="M91.298 34.077 29.875 25.03a2.85 2.85 0 0 0-2.3.676c-.135.119-.27.254-.372.406l-7.508-1.082a2.87 2.87 0 0 0-2.283.676 2.3 2.3 0 0 0-.339.372l-7.56-1.048A2.863 2.863 0 0 0 6.25 27.87v41.213c.001.761.305 1.505.863 2.046a2.92 2.92 0 0 0 2.013.83h.034l7.56-.085c.134.287.32.558.557.794a2.91 2.91 0 0 0 2.013.83h.034L27 73.396c.119.203.271.405.44.575a2.92 2.92 0 0 0 2.013.828h.033l61.423-.795a2.876 2.876 0 0 0 2.841-2.874V36.918a2.875 2.875 0 0 0-2.452-2.842M16.397 66.125l-4.43.05V31.17l4.43.608zm10.18-32.944v34.466l-4.43.05V31.17l4.43.625v1.387m61.44 35.108-4.43.051-2.876.034-7.322.101-41.061.541V31.202l38.203 5.632 2.874.423 7.306 1.082 2.875.423 4.431.66v28.884z"
    ></path>
    <path
      fill="#CFCFCF"
      d="M58.676 43.802c-.17-.187-.423-.068-.423.22v15.186c0 .27.254.456.423.321l10.045-6.46c.152-.118.152-.389 0-.541z"
    ></path>
  </svg>
);

export default DisplayIconSecondary;
